import React from 'react';
import _ from 'lodash';
import cx from 'classnames';
import i18n from 'i18next';
var t = i18n.getFixedT(null, 'setting-service');
var ServiceMonitorCard = /*#__PURE__*/React.memo(function (props) {
  var updateTime = props.updateTime,
      onDialogOpen = props.onDialogOpen,
      data = props.data;

  var hanleOpenDialog = function hanleOpenDialog(d) {
    onDialogOpen(d);
  };

  var renderWaittingComponent = function renderWaittingComponent() {
    return /*#__PURE__*/React.createElement("div", {
      className: "loading"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-circle-notch fa-spin fa-3x fa-fw"
    }));
  };

  var renderContent = function renderContent() {
    return /*#__PURE__*/React.createElement("div", {
      className: "content"
    }, data.fetchStatus === 'error' && /*#__PURE__*/React.createElement("div", {
      className: true
    }, t('lbl-no-data')), data.fetchStatus === 'complete' && /*#__PURE__*/React.createElement("div", {
      className: "status"
    }, /*#__PURE__*/React.createElement("i", {
      className: cx('fas fa-circle status', data.status.toUpperCase())
    }), t('lbl-' + data.status.toUpperCase())), /*#__PURE__*/React.createElement("div", {
      className: "updateAt"
    }, /*#__PURE__*/React.createElement("i", {
      class: "far fa-clock"
    }), /*#__PURE__*/React.createElement("span", null, t('lbl-update-time'), ": ", updateTime)));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "card",
    onClick: function onClick() {
      return hanleOpenDialog(data);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, data.title), data.fetchStatus === 'loading' ? renderWaittingComponent() : renderContent());
});
export default ServiceMonitorCard;